module.exports = __webpack_public_path__ + "img/api_key.7c57fe49.svg";